import React from "react";
import { CustomButton } from "./CustomButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { HiInformationCircle } from "react-icons/hi";
import { SenderEmailGate } from "../../hooks/useSenderEmailGate";

type Props = {
  gate: SenderEmailGate;
  className?: string;
};

const SETTINGS_SENDER_EMAIL_ROUTE = "/control-panel/settings#emailSenderConfig";

const SenderEmailGateBanner: React.FC<Props> = ({ gate, className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (gate.canSend) return null;

  const message =
    gate.reason === "default"
      ? t("dashboard.entities.emailSenderValidation.defaultDomainBlockMessage")
      : t("dashboard.entities.emailSenderValidation.unverifiedBlockMessage");

  return (
    <div
      className={
        "rounded-lg bg-red-50 p-3 border border-red-200 flex flex-col sm:flex-row sm:items-start gap-3 " +
        (className ?? "")
      }
      role="alert"
    >
      <p className="flex-1 text-sm text-red-800 font-medium flex items-start gap-2">
        <HiInformationCircle className="w-5 h-5 mt-0.5 shrink-0" />
        <span>{message}</span>
      </p>
      <CustomButton
        variant="primary"
        onClick={() => navigate(SETTINGS_SENDER_EMAIL_ROUTE)}
        title={t("dashboard.entities.emailSenderValidation.btnUpdateSender")}
        className="w-full shrink-0 whitespace-nowrap sm:w-auto"
      />
    </div>
  );
};

export default SenderEmailGateBanner;
